// extracted by mini-css-extract-plugin
module.exports = {"compareSection":"CompareSection_compareSection__tBI_a","compareCloseBtn":"CompareSection_compareCloseBtn__Efls3"};